import { defineStore } from "pinia";

export const mainStore = defineStore("mainStore", {
  state: () => ({
    apiURL: "https://api.flightiy.com",
    globalAlertType: "",
    globalAlertTitle: "",
    globalAlertText: "",
    btn_text: "Close",
    globalAlert: false,
  }),
  actions: {
    handleErr(type, title, text) {
      this.globalAlertType = type;
      this.globalAlertTitle = title;
      this.globalAlertText = text;
      this.globalAlert = true;
    },
  },
});
